import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS, DEFAULT_FILTER_AGENTS_QUERY_PARAMS } from "../api";
import { AgentListFilterForm } from "../components/forms/AgentListFilterForm";
import { AgentListTable } from "../components/tables/AgentListTable";
import { AgentFilterPageRequest } from "../types";

export const AgentListContainer = () => {
  const searchParams = useFilterSearchParams<AgentFilterPageRequest>({
    params: [...COMMON_AGENT_FILTER_SEARCH_PARAMS],
    defaultQueryParamsObject: DEFAULT_FILTER_AGENTS_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <AgentListFilterForm searchParams={searchParams} />

      <AgentListTable searchParams={searchParams} />
    </ContentWrapper>
  );
};
